import classNames from 'classnames';
import { forwardRef, PropsWithChildren } from 'react';
import styles from './Section.module.scss';

export type SectionProps = {
  className?: string;
  size?: 'medium' | 'large';
  color?: 'gray' | 'primary';
} & JSX.IntrinsicElements['div'];

export const Section = forwardRef<HTMLDivElement, PropsWithChildren<SectionProps>>(function Section(
  { className, size = 'medium', color = '', children, ...props },
  ref
) {
  return (
    <section
      className={classNames(styles.root, styles[size], styles[color], className)}
      {...props}
      ref={ref}>
      {children}
    </section>
  );
});
